module.exports = __webpack_public_path__ + "static/pool-7b2be628b147d44becc01682f311c4f2.gif";